/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol extends models.ServiceAccountEphemeralCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol>): ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol(), model);
        ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol>): ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol.newInstance(<ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol): boolean {
        if (models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Token
     */
    authorization_token: string;

}
